import {NfGlobalMessage} from "../NfGlobalMessage";
import {NfMessage, NfMessageType} from "../NfMessage";
import type {ModalTypes} from "../../../frontendClasses/ModalTypes";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";

/**
 * Prośba o stworzenie nowego modala, service worker prześle ją jako globalną do modułu odpowiedzialnego za tworzenie modali
 */
export class NewModalRequest extends NfComponentGlobalMessage {
    declare public modalType: ModalTypes;
    public modalData: any;

    /**
     *
     * @param modalType
     * @param modalData Uwaga, modalData musi być serializowalne, dopuszczalne jest wysyłanie momentów i podstawowych typów danych
     */
    public constructor(modalType: ModalTypes|MessageEvent<NewModalRequest>, modalData?: any) {
        super(NfMessageType.NewModalRequest, !NfMessage.isMessageEvent(modalType));
        if(NfMessage.isMessageEvent(modalType)) {
            Object.assign(this, modalType.data);
        } else {
            if(!modalType) {
                throw Error('modalType jest wymagany');
            }
            this.modalType = modalType;
            this.modalData = this.serialize(modalData);
        }
    }

    public getModalData() {
        return this.deserialize(this.modalData);
    }
}
NfMessage.creationCallbacks[NfMessageType.NewModalRequest] = (event) => {
    return new NewModalRequest(event);
}
